import { Component, HostListener, ViewChild } from '@angular/core';
import { LegAction } from './trip-assingned-history.interface';
import { TripAssignedDetailsComponent } from '../trip-assigned-details/trip-assigned-details.component';
import { DialogService } from 'src/app/core/services/dialog.service';

@Component({
  selector: 'app-trip-assigned-history',
  templateUrl: './trip-assigned-history.component.html',
  styleUrls: ['./trip-assigned-history.component.scss']
})
export class TripAssignedHistoryComponent {
  @ViewChild('assignedTripDetail') assignedTripDetail: TripAssignedDetailsComponent;

  private _visibility: boolean = false;
  private _title: string = 'Trip Details';
  private _data: LegAction[] = [
    { name: 'Pick Up', active: true },
    { name: 'In Transit', active: false },
    { name: 'Cruse - SB', active: false },
    { name: 'In Transit', active: false },
    { name: 'Entrega - SB', active: false },
    { name: 'In Transit', active: false },
  ];

  constructor(
    private readonly dialogService: DialogService,
  ) { }

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed() {
    if(this.dialogService.isTopMost(this)) {
      this.hide();
    }
  }

  get visibility() {
    return this._visibility;
  }

  get title() {
    return this._title;
  }

  get data() {
    return this._data;
  }

  setTitle(title: string) {
    this._title = title;
  }

  setData(data: LegAction[]) {
    this._data = data;
  }

  show() {
    this._visibility = true;
    this.dialogService.registerDialog(this);
  }

  hide() {
    this._visibility = false;
    this.dialogService.unregisterDialog(this);
  }

  onLegClicked(data: LegAction) {
    console.log('Leg clicked:', data);
    this.assignedTripDetail.setTitle(data.name);
    this.assignedTripDetail.show()
  }
}
